import React from "react"
import { Icon } from "@components"
import { View } from "react-native"
import { useTheme } from "@react-navigation/native"
import getStyle from "./style"

export const Pin = ({isFocused, color} : {isFocused?: boolean, color?: string}) => {
    const theme = useTheme()
    const styles = getStyle(theme)
  
    return (
        <View style={styles.pinButton}>
            <Icon name="pin" size={20} color={isFocused? color : theme.colors.greyBlue} />
        </View>
    )
}